export default __webpack_public_path__ + "static/media/module-library.883cae2b.svg";